var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Button_Icon",
    "data-name": "Button Icon",
    d: "M-4-11a2.983,2.983,0,0,1,3-3,3,3,0,0,1,3,3v8A2,2,0,0,1,0-1,2,2,0,0,1-2-3V-9.5a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V-3A1,1,0,0,0,0-2,1,1,0,0,0,1-3v-8a2,2,0,0,0-2-2,2,2,0,0,0-2,2v9A2.983,2.983,0,0,0,0,1,3,3,0,0,0,3-2V-9.5a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V-2A4,4,0,0,1,0,2,4,4,0,0,1-4-2v-9Z",
    transform: "translate(4 14)",
    fill: "#444a5e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.bea6e72414ce22e68379ef75e237b409.svg";
export { ForwardRef as ReactComponent };